// Attach search query to relevant points
const urlParams = new URLSearchParams(window.location.search);
const searchQuery = urlParams.get('q'); 

const searchTermInput = document.querySelector('#search-term');

if (searchQuery) {
    document.querySelectorAll('.search-query').forEach(el => {
        el.textContent = `product: ${searchQuery}`;
        searchTermInput.value = searchQuery;
        searchTermInput.placeholder = searchQuery;
    })
} else {
    // If no search query use general content
    document.querySelectorAll('.search-query').forEach(el => {
    el.textContent = 'the product you are looking for';
    })
    searchTermInput.value = "N/A";
    searchTermInput.placeholder = "N/A";
}


document.querySelector('#empty-search_form').addEventListener('submit', function(e) {
    e.preventDefault();
    console.log('event started');

    // Prepare formdata for HubSpot Submission      
    const formData = {
      fields: [
          {
              objectTypeId: "contact",
              name: "firstname",
              value: document.querySelector('#contact-form-fname') ? document.querySelector('#contact-form-fname').value : "ERROR: Element not found"
          },
          {
              objectTypeId: "contact",
              name: "lastname",
              value: document.querySelector('#contact-form-lname') ? document.querySelector('#contact-form-lname').value : "ERROR: Element not found"
          },
          {
              objectTypeId: "contact",
              name: "email",
              value: document.querySelector('#contact-form-email') ? document.querySelector('#contact-form-email').value : "ERROR: Element not found"
          },
          {
              objectTypeId: "contact",
              name: "mobilephone",
              value: document.querySelector('#contact-form-mobile_number') ? document.querySelector('#contact-form-mobile_number').value : "ERROR: Element not found"
          },
          {
              objectTypeId: "contact",
              name: "company",
              value: document.querySelector('#contact-form-company_name') ? document.querySelector('#contact-form-company_name').value : "ERROR: Element not found"
          },
        
          {
            objectTypeId: "contact",
            name: "search_term",
            value: document.querySelector('#search-term') ? document.querySelector('#search-term').value : "ERROR: Element not found"
          },
          {
            objectTypeId: "contact",
            name: "item_type",
            value: document.querySelector('#item_type') ? document.querySelector('#item_type').value : "ERROR: Element not found"
          }
      ]
  }
  
//   console.log(formData);

        // Submit to HubSpot
        fetch('https://api.hsforms.com/submissions/v3/integration/submit/43764379/7c1cd5c6-55bc-4360-8eb7-53b59da0e3a9', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => {
              console.error('HubSpot Error Message:', err.message);
              console.error('HubSpot Error Details:', err.errors); // This might contain an array of error details
              throw new Error('Network response was not ok');
            });
          }
          return response.json();
        })
        .then(data => {
            console.log('Form submitted successfully!', data);
            // Handle success actions, maybe redirect or show a thank you message
            window.location.href = '/pages/form-submitted';
        })
        .catch(error => {
            console.error('Error submitting form to HubSpot', error);
            // Handle error actions, maybe show an error message to the user
            alert('There was an issue submitting the form. Please check your entries and try again.');
    
        });
    });
